import { EnvConfig } from '@digilize/shared/definitions/src';

declare var WEBPACK_DEFINE_VERSION: string; //webpack will change version to time of build, see webpack.config.js

export const getTranslationSuffix = (envConfig: EnvConfig) => {
  return !envConfig.development && typeof WEBPACK_DEFINE_VERSION !== 'undefined'
    ? `.json?v=${WEBPACK_DEFINE_VERSION}`
    : '.json';
};
